import React from 'react';
import preferenceImage from './icon_gear.svg';

const PreferenceIcon = () => {
  return <img src={preferenceImage} alt="preference-image" />;
};

PreferenceIcon.propTypes = {};

export default PreferenceIcon;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Header/components/PreferenceIcon/index.js
 **/